<template>
  <v-card>
    <v-toolbar flat height="50">
      <v-toolbar-title>Biometric Finger Details</v-toolbar-title>
    </v-toolbar>
    <div v-if="project" class="pa-4">
      <v-layout row wrap>
        <v-flex md4>
          <strong>Biometric Finger Schedule Date </strong><br />
          <p>{{ project.biometric_finger_schedule_date  }}</p>
        </v-flex>
        <v-flex md4>
          <strong>Visa issue date</strong><br />
          <p>{{ project.visa_issue_date}}</p>
        </v-flex>
        <v-flex md4>
          <strong>Visa Expiry date</strong><br />
          <p>{{ project.visa_expiry_date}}</p>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import {
  MEDICAL_STATUSES,
  VISA_TYPES,
  SERVICE_TYPES,
  PROJECT_OWNER,
} from "../../mdsir/const";

import {
  valueToText,
  getTV,
  districtTV,
  upazilaTV,
  unionTV,
} from "../../mdsir/MdsirUtils";

export default {
  props: ["project"],
  data() {
    return {
      PROJECT_OWNER: PROJECT_OWNER
    };
  },

  // computed: {},

  methods: {
    renderProp(item) {
      const { key } = item;
      let value = this.project[key];
      switch (key) {
        case "medical_status":
          value = value ? valueToText(MEDICAL_STATUSES, value) : "";
          break;
        case "service_type":
          value = value ? valueToText(SERVICE_TYPES, value) : "";
          break;
        case "trade_name":
          value = value ? valueToText(VISA_TYPES, value) : "";
          break;
        case "project_owner":
          value = value ? valueToText(PROJECT_OWNER, value) : "";
          break;

        default:
          break;
      }
      return value;
    },
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
    valueToText: valueToText,
  },

  // mounted() {},

  // watch: {},

  // beforeDestroy() {},

  // created() {},
};
</script>
